module.exports = "../dist/img/product-detail-2-24.e68a.jpg";